export default {
  type: {
    label: '文件类型',
    type: 'select',
    optionList: [],
    rules: [{ required: true, message: '请选择文件类型' }], // 校验
  },
  code: {
    label: '文件编号',
    type: 'input',
  },
  insuranceName: {
    label: '保险公司名称',
    type: 'input',
  },
  efficientDate: {
    label: '生效日期',
    type: 'datePicker',
    dateFormat: 'YYYY-MM-DD',
    rules: [{ required: true, message: '请选择生效日期' }], // 校验
    showTime: false,
  },
  expireDate: {
    label: '到期日期',
    type: 'datePicker',
    dateFormat: 'YYYY-MM-DD',
    rules: [{ required: true, message: '请选择到期日期' }], // 校验
  },
  currencyUnit: {
    label: '货币单位',
    type: 'select',
    optionList: [
      {
        label: 'RMB',
        value: 1,
      },
      {
        label: 'USD',
        value: 2,
      },
    ],
    rules: [{ required: true, message: '请选择货币单位' }], // 校验
  },
  amount: {
    label: '保险金额',
    type: 'input',
    rules: [{ required: true, message: '请输入保险金额' }], // 校验
  },
  remark: {
    label: '备注',
    type: 'input',
  },
}
